import "./style.css";
import 'swiper/css';
import 'swiper/css/pagination';
import React, { useEffect, useState } from "react";
import * as yup from "yup";
import { useFormik } from "formik";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { failed } from "@components/Common/Toastify";
import { phoneVerification, getVerificationStatus } from "../../API/Auth";
import borrowerImg1 from "../../Assets/Images/borrwr-img-one.png";
import borrowerImg2 from "../../Assets/Images/borrwr-img-two.png";
import borrowerImg3 from "../../Assets/Images/borrwr-img-three.png";
import borrowerImg4 from "../../Assets/Images/borrwr-img-four.png";
import borrowerImg5 from "../../Assets/Images/borrwr-img-five.png";
import lenderImg1 from "../../Assets/Images/banner-one.png";
import lenderImg2 from "../../Assets/Images/banner-two.png";
import lenderImg3 from "../../Assets/Images/banner-3.png";
import lenderImg4 from "../../Assets/Images/banner-four.png";
import lenderImg5 from "../../Assets/Images/banner-five.png";
import PhoneInput from "react-phone-input-2";
import storage from "@utils/storage";
import axios from "axios";
import envConfig from "../../environment";
import righticon from "../../Assets/Images/right-icon.png";

export const PhoneVerification = () => {
    const navigate = useNavigate();
    const SHUFTIPRO_CLIET_ID = envConfig.SHUFTIPRO_CLIET_ID;
    const SHUFTIPRO_SECRET_KEY = envConfig.SHUFTIPRO_SECRET_KEY;
    const Id = storage.getUserType();
    console.log("Id", Id);
    const role = Id?.userType;
    const location = useLocation();
    const userDataFromState = location.state?.userData;
    console.log("userDataFromState", userDataFromState);
    const roleTypeFromState = location.state?.roleType;
    const initialUserData = userDataFromState ?? Id;
    const roleType = roleTypeFromState ?? role;
    const [userData, setUserData] = useState(initialUserData);
    const phoneNumberFromState = userData?.phoneNumber || userData?.data?.phoneNumber || "";
    const [selectedUserType, setSelectedUserType] = useState<
        "borrower" | "lender"
    >("borrower");
    const borrowerImages = [borrowerImg1, borrowerImg2, borrowerImg3, borrowerImg4, borrowerImg5];
    const lenderImages = [lenderImg1, lenderImg2, lenderImg3, lenderImg4, lenderImg5];
    const [, setCurrentImageIndex] = useState(0);
    const [btnLoading, setBtnLoading] = useState(false);
    const [isPhoneVerified, setIsPhoneVerified] = useState(false);

    const userID = userData?.uuid || userData?.data?.uuid || userData?.userId;

    const handlePhoneSkipSuccess = (data: Record<string, unknown>) => {
        const user = {
            ...userData,
            uuid: data.uuid || userID,
            email: data.email ?? userData?.email,
            phoneNumber: data.phoneNumber ?? userData?.phoneNumber,
            userType: data.userType ?? roleType,
        };
        storage.setUserType(user);
        setUserData(user);
        setIsPhoneVerified(true);

        if (envConfig.SKIP_PHONE_VERIFICATION) {
            navigate("/auth/document-verification", {
                state: { roleType, userData: user },
            });
        }
    };

    useEffect(() => {
        const loginPage = document.querySelector(".onboarding-page");
        if (loginPage) {
            loginPage.classList.remove("theme-borrower", "theme-lender");
            loginPage.classList.add(`theme-${roleType}`);
        }
    }, [roleType]);

    useEffect(() => {
        if (roleType === "borrower" || roleType === "lender") {
            setSelectedUserType(roleType);
        }
    }, [roleType]);

    useEffect(() => {
        const interval = setInterval(() => {
            setCurrentImageIndex(
                (prevIndex) =>
                    (prevIndex + 1) %
                    (roleType === "borrower"
                        ? borrowerImages.length
                        : lenderImages.length)
            );
        }, 5000);
        return () => clearInterval(interval);
    }, [borrowerImages.length, lenderImages.length, roleType]);

    const formik = useFormik({
        enableReinitialize: true,
        initialValues: {
            phoneNumber: phoneNumberFromState,
        },
        validationSchema: yup.object({
            phoneNumber: yup
                .string()
                .required("Phone number is required")
                .matches(/^\+?[1-9]\d{7,14}$/, "Enter a valid phone number"),
        }),
        onSubmit: (values) => {
            setBtnLoading(true);
            storage.setUserType({
                ...userData,
                uuid: userID,
            });
            phoneVerification({
                phoneNumber: values.phoneNumber,
                userType: roleType,
                userId: userID,
            })
                .then((res: any) => {
                    const { data } = res?.data || {};
                    if (data?.verificationUrl) {
                        window.location.href = data.verificationUrl;
                    } else if (data?.skipped) {
                        handlePhoneSkipSuccess(data);
                    }
                })
                .catch((err) => {
                    failed(err?.response?.data?.message || "Something went wrong");
                })
                .finally(() => setBtnLoading(false));
        },
    });

    useEffect(() => {
        if (
            envConfig.SKIP_PHONE_VERIFICATION &&
            userID &&
            phoneNumberFromState &&
            !isPhoneVerified &&
            !btnLoading
        ) {
            setBtnLoading(true);
            phoneVerification({
                phoneNumber: phoneNumberFromState,
                userType: roleType,
                userId: userID,
            })
                .then((res: any) => {
                    const { data } = res?.data || {};
                    if (data?.skipped) {
                        handlePhoneSkipSuccess(data);
                    }
                })
                .catch((err) => {
                    failed(err?.response?.data?.message || "Something went wrong");
                })
                .finally(() => setBtnLoading(false));
        }
    }, []);

    useEffect(() => {
        let isMounted = true;
        let pollCount = 0;
        const maxPolls = 20;
        let intervalId: any = null;

        const checkStatus = async () => {
            if (!userID) return;
            try {
                const response = await getVerificationStatus(userID);
                const data = response.data?.data;
                if (data?.isPhoneNumberVerified && isMounted) {
                    setIsPhoneVerified(true);
                    if (intervalId) clearInterval(intervalId);
                }
            } catch (error) {
                console.error("Error fetching verification status from backend:", error);
            }
        };

        if (userID) {
            checkStatus();

            intervalId = setInterval(() => {
                pollCount++;
                if (pollCount >= maxPolls) {
                    if (intervalId) clearInterval(intervalId);
                } else {
                    checkStatus();
                }
            }, 3000);
        }

        return () => {
            isMounted = false;
            if (intervalId) clearInterval(intervalId);
        };
    }, [userID]);

    useEffect(() => {
        if (isPhoneVerified) {
            const timer = setTimeout(() => {
                navigate("/auth/document-verification", {
                    state: { roleType, userData },
                });
            }, 2000);
            return () => clearTimeout(timer);
        }
    }, [isPhoneVerified, navigate, roleType, userData]);

    console.log("isPhoneVerified", isPhoneVerified);

    return (
        <div className="">
            <div className="row onboarding-page fg-pw theme-borrower">
                {/* <div className="col-lg-6 bg-image p-0">
                    <div className="swiper-inner position-relative">
                        <Swiper
                            pagination={true}
                            modules={[Pagination]}
                            className="swiper-block"
                            onSlideChange={(swiper) => setCurrentImageIndex(swiper.activeIndex)}
                        >
                            {(selectedUserType === "borrower" ? borrowerImages : lenderImages).map(
                                (imgSrc, index) => (
                                    <SwiperSlide key={index}>
                                        <div className="slider-images-block">
                                            <div className="slider-banner">
                                                <img src={imgSrc} alt="" className="img-fluid w-100" />
                                            </div>
                                            <div className="lendriva-logo-auth position-absolute">
                                                <img src={lendriva_logo} alt="" className="img-fluid" />
                                            </div>
                                            <div className="overlay-content text-center">
                                                <h5 className="overlay-heading">Welcome to Lendriva!</h5>
                                                <p className="overlay-heading">
                                                    Empowering Your Financial Journey with Community Support
                                                </p>
                                            </div>
                                        </div>
                                    </SwiperSlide>
                                )
                            )}
                        </Swiper>
                    </div>
                </div> */}

                <div className="p-0 d-flex flex-column align-items-center my-3">
                    <div className="login-btn-call d-flex justify-content-between">
                        <div className="return-home">
                            <Link
                                to="/auth/login"
                                state={{ roleType }}
                                className="return text-decoration-none align-ittems-center d-flex"
                            >
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 24 24"
                                    width="23"
                                    height="23"
                                    style={{ display: 'block', filter: 'brightness(0) invert(1)' }}
                                >
                                    <path
                                        d="M15.41 7.41 10.83 12l4.58 4.59L14 18l-6-6 6-6z"
                                        fill="#000000"
                                    />
                                </svg>


                                {/* <img src={lefticon} alt="back" className="img-fluid" /> */}
                                <span className="ms-1 return-home">Login</span>
                            </Link>
                        </div>
                    </div>

                    <div className="lower-div">
                        <div className="credentials-box">
                            {!isPhoneVerified && (
                                <div className="heading-para-block">
                                    <h2 className="text-center">Phone Verification</h2>
                                    <p className="text-center enter-address">
                                        Please enter the Phone Number associated with your account.
                                    </p>
                                </div>
                            )}
                            <form className="onboarding-form" onSubmit={formik.handleSubmit}>
                                {isPhoneVerified ? (
                                    <div className="text-center mt-3">
                                        <div className="d-flex flex-column gap-4 align-items-center justify-content-center mb-4">
                                            <div>
                                                <span className="me-2"><img src={righticon} alt="" /></span>
                                            </div>
                                            <h4 >Phone Verified Successfully</h4>
                                        </div>
                                        <div className="btn btn-borrower proceed-button signin w-100">
                                            <Link
                                                className="text-decoration-none text-white"
                                                style={{ paddingTop: "4px" }}
                                               to="/auth/document-verification"
                                                state={{ roleType, userData }}
                                            >
                                                Proceed to Document Verification
                                            </Link>
                                        </div>
                                    </div>
                                ) : (
                                    <>
                                        <div className="mb-4 ph-no-verification">
                                            <label htmlFor="phoneNumber" className="form-label">
                                                Phone Number <span className="text-orange">*</span>
                                            </label>
                                            <PhoneInput
                                                country="in"
                                                placeholder="Phone Number"
                                                value={formik.values.phoneNumber}
                                                onChange={(value) => {
                                                    const normalized = value.startsWith('+') ? value : `+${value}`;
                                                    formik.setFieldValue('phoneNumber', normalized);
                                                }}
                                                onBlur={() => formik.setFieldTouched('phoneNumber', true)}
                                                inputProps={{
                                                    name: 'phoneNumber',
                                                    required: true,
                                                    autoFocus: false,
                                                }}
                                                inputClass={
                                                    formik.touched.phoneNumber && formik.errors.phoneNumber
                                                        ? "input-error"
                                                        : ""
                                                }
                                            />
                                        </div>
                                        <button
                                            type="submit"
                                            className="btn btn-borrower signin w-100"
                                            disabled={btnLoading}
                                        >
                                            {btnLoading ? "Verifying..." : "Verify Phone Number"}
                                        </button>
                                    </>
                                )}
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PhoneVerification;
